import { Commercial } from '../../types/api/endpoints/commercial/commercial.types';
import { LoginStatus } from '../../types/models/status/status.types';
import { User, UserDIR, UserENT, UserPUB, UserRoles } from '../../types/models/user/user.types';
import { routesList } from '../router.data';

export const getRouterScreens = (
  profile: User | UserPUB | UserENT | UserDIR | Commercial | null
) => {
  // console.log('router', Boolean(profile), profile)
  if (profile) {
    if (profile.role === UserRoles.AcheteurPublic && profile.id_step === 5) {
      return routesList[LoginStatus.Logged][profile.role];
    } else if (profile.role === UserRoles.Entreprise && profile.id_step === 3) {
      return routesList[LoginStatus.Logged][profile.role];
    } else if (![UserRoles.AcheteurPublic, UserRoles.Entreprise].includes(profile.role)) {
      return routesList[LoginStatus.Logged][profile.role];
    } else {
      return routesList[LoginStatus.NotFinalized];
    }
  } else {
    return routesList[LoginStatus.NotLogged];
  }
};
